import dynamic from "next/dynamic"
import antiXss from "../../../../common/utils/anti-xss"
import ErrorView from "../../../shared/ErrorView"

const RichTextLabel = dynamic(() => import("../../../shared/RichTextLabel"), {
  ssr: false,
})

type Props = {
  searchTerm: string
}

const NoResultsView = ({ searchTerm }: Props) => {
  const sanitizedSearchTerm = antiXss(searchTerm)
  return (
    <ErrorView>
      <RichTextLabel
        i18nKey="search-no-results-header_rtf"
        values={{ searchTerm: sanitizedSearchTerm }}
        styleProps={{ fontSize: { base: "5xl", sm: "7xl", md: "8xl" }, mb: "8" }}
      />
      <RichTextLabel i18nKey="search-no-results-info_rtf" styleProps={{ fontSize: { base: "lg", sm: "xl" } }} />
    </ErrorView>
  )
}

export default NoResultsView
